import React from 'react';

function PowerIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9991 22C6.9996 22 3 17.9672 3 13.1475C3 10.2951 4.39986 7.54098 6.89961 5.86885C7.39956 5.57377 7.9995 5.67213 8.29947 6.06557C8.59944 6.55738 8.49945 7.14754 7.9995 7.44262C6.09969 8.72131 4.9998 10.8852 4.9998 13.1475C4.9998 16.9836 8.19948 20.0328 11.9991 20.0328C15.8987 20.0328 18.9984 16.8852 18.9984 13.1475C18.9984 10.9836 17.8985 8.81967 16.0987 7.54098C15.6987 7.2459 15.5987 6.65574 15.8987 6.16393C16.1987 5.67213 16.8986 5.67213 17.2986 5.96721C19.5983 7.63934 20.9982 10.2951 20.9982 13.1475C21.0982 18.0656 16.9986 22 11.9991 22ZM12.999 13.7377V4.98361C12.999 4.39344 12.599 4 11.9991 4C11.3992 4 10.9992 4.39344 10.9992 4.98361V13.7377C10.9992 14.3279 11.3992 14.7213 11.9991 14.7213C12.599 14.7213 12.999 14.2295 12.999 13.7377Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default PowerIcon;
